<div id="dsw">

    <div class="popup-header z-index modal-header">
        <div class="flex-center space-between d-flex w-100">
            <h2 translate>lblAddDetails</h2>
            <em class="fas fa-times close-icn-popup popup-close ml-auto" (click)="activeModal.close(false)"></em>
        </div>
    </div>
    <form [formGroup]="CustomerVehicleForm" (ngSubmit)="onCustomerVehicleFormSubmit()">
        <div class="modal-body">
        <div class="row xsmbt0">
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblRegNumber<strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong></label>
                        <input type="text" maxlength="30" class="form-control" [readonly]="!isDFVehicleFound" formControlName="LicensePlate" disabled/>
                    </div>
                </div>
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblVinNumber<strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong></label>
                        <input type="text" maxlength="25" class="form-control" [readonly]="!isDFVehicleFound" formControlName="VinNumber" />
                    </div>
                </div>
            </div>
            <div class="row xsmbt0">
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>Vehicle Type<strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong> </label>
                        <input type="text" *ngIf="!isDFVehicleFound" readonly class="form-control" formControlName="vehicleGroup" />
                        <ng-select *ngIf="isDFVehicleFound" formControlName="vehicleGroup" placeholder="{{ 'lblSelectVehical' | translate }}"
                        [ngClass]="(CustomerVehicleFormControls.vehicleGroup.touched || CustomerVehicleFormControls.vehicleGroup.dirty) && CustomerVehicleFormControls.vehicleGroup.errors?.required && isDFVehicleFound ? 'isinvalid' : ''"    
                        >
                            <ng-template ng-header-tmp>
                                <span class="mbold w-66px">Code</span>
                                <span class="mbold" translate>lblVehicalType</span>
                            </ng-template>
                        
                            <ng-option *ngFor="let item of vehicleGroupList" [value]="item.code">
                                <span class="w-66px">{{item.code}}</span>
                                <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                <span>{{item.name}}</span>
                            </ng-option>
                        </ng-select>
                        <div *ngIf="CustomerVehicleFormControls.vehicleGroup.touched || CustomerVehicleFormControls.vehicleGroup.dirty">
                            <div translate *ngIf="CustomerVehicleFormControls.vehicleGroup.errors?.required && isDFVehicleFound" class="cst-validation-msg">
                                lblVehicleGroupRequired
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblMakeName  <strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong></label>
                        <input type="text" class="form-control" *ngIf="!isDFVehicleFound" readonly formControlName="MakeName" />

                        <ng-select *ngIf="isDFVehicleFound" formControlName="MakeName" placeholder="{{ 'lblSelectMake' | translate }}" 
                        required (change)="onMakeSelected($event)"
                        [ngClass]="(CustomerVehicleFormControls.MakeName.touched || CustomerVehicleFormControls.MakeName.dirty) && CustomerVehicleFormControls.MakeName.errors?.required && isDFVehicleFound ? 'isinvalid' : ''"    
                        >
                            <ng-template ng-header-tmp>
                                <span class="mbold w-66px">Code</span>
                                <span class="mbold" translate>lblMake</span>
                            </ng-template>
                        
                            <ng-option *ngFor="let type of makeList" [value]="type.brandName">
                                <span class="w-66px">{{type.brandCode}}</span>
                                <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                <span>{{type.brandName}}</span>
                            </ng-option>
                        </ng-select>
                        <div *ngIf="CustomerVehicleFormControls.MakeName.touched || CustomerVehicleFormControls.MakeName.dirty">
                            <div translate *ngIf="CustomerVehicleFormControls.MakeName.errors?.required && isDFVehicleFound" class="cst-validation-msg">
                                lblMakeNameRequired
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row xsmbt0">
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblModel <strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong> </label>
                        <input type="text" *ngIf="!isDFVehicleFound" class="form-control" readonly formControlName="Model" />
                        <ng-select *ngIf="isDFVehicleFound" formControlName="Model" class="form-control"
                        [ngClass]="(CustomerVehicleFormControls.Model.touched || CustomerVehicleFormControls.Model.dirty) && CustomerVehicleFormControls.Model.errors?.required && isDFVehicleFound ? 'isinvalid' : ''"    
                        >
                            <ng-option *ngFor="let type of modelList" [value]="type.description">
                                {{type.description}}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="CustomerVehicleFormControls.Model.touched || CustomerVehicleFormControls.Model.dirty">
                            <div translate *ngIf="CustomerVehicleFormControls.Model.errors?.required && isDFVehicleFound" class="cst-validation-msg">
                                lblModelRequired
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblYear <strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong> </label>
                        <input type="text" [readonly]="!isDFVehicleFound" formControlName="Year" 
                        [ngClass]="(CustomerVehicleFormControls.Year.touched || CustomerVehicleFormControls.Year.dirty) && CustomerVehicleFormControls.Year.errors?.required && isDFVehicleFound ? 'isinvalid' : ''"    
                        class="form-control" />
                        <div *ngIf="CustomerVehicleFormControls.Year.touched || CustomerVehicleFormControls.Year.dirty">
                            <div translate *ngIf="CustomerVehicleFormControls.Year.errors?.required && isDFVehicleFound" class="cst-validation-msg">
                                lblYearRequired
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row xsmbt0">
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblFuelType <strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong></label>
                        <input type="text" *ngIf="!isDFVehicleFound" readonly formControlName="fuelType" class="form-control" />

                        <ng-select *ngIf="isDFVehicleFound" formControlName="fuelType" 
                        placeholder="{{ 'lblSelectFuelType' | translate }}" 
                        [ngClass]="(CustomerVehicleFormControls.fuelType.touched || CustomerVehicleFormControls.fuelType.dirty) && CustomerVehicleFormControls.fuelType.errors?.required && isDFVehicleFound ? 'isinvalid' : ''"    
                        >
                            <ng-template ng-header-tmp>
                                <span class="mbold w-66px">Code</span>
                                <span class="mbold" translate>lblFuelType</span>
                            </ng-template>
                        
                            <ng-option *ngFor="let type of fuels" [value]="type.fuelType">
                                <span class="w-66px">{{type.fuelType}}</span>
                                <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                <span>{{type.description}}</span>
                            </ng-option>
                        </ng-select>
                        <div *ngIf="CustomerVehicleFormControls.fuelType.touched || CustomerVehicleFormControls.fuelType.dirty">
                            <div translate *ngIf="CustomerVehicleFormControls.fuelType.errors?.required && isDFVehicleFound" class="cst-validation-msg">
                                lblFuelTypeRequired
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblTransmission <strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong></label>
                        <input type="text" *ngIf="!isDFVehicleFound" readonly formControlName="transmission" class="form-control" />
                        <ng-select formControlName="transmission" 
                        placeholder="{{ 'lblSelectTransmission' | translate }}"
                        [ngClass]="(CustomerVehicleFormControls.transmission.touched || CustomerVehicleFormControls.transmission.dirty) && CustomerVehicleFormControls.transmission.errors?.required && isDFVehicleFound ? 'isinvalid' : ''"    
                        *ngIf="isDFVehicleFound">
                            <ng-template ng-header-tmp>
                                <span class="mbold w-66px">Code</span>
                                <span class="mbold" translate>lblTransmission</span>
                            </ng-template>
                        
                            <ng-option *ngFor="let item of vehicleTransmissionList" [value]="item.transmisionName">
                                <span class="w-66px">{{item.code}}</span>
                                <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                <span>{{item.transmisionName}}</span>
                            </ng-option>
                        </ng-select>


                        <div *ngIf="CustomerVehicleFormControls.transmission.touched || CustomerVehicleFormControls.transmission.dirty">
                            <div translate *ngIf="CustomerVehicleFormControls.transmission.errors?.required && isDFVehicleFound" class="cst-validation-msg">
                                lblTransmissionRequired
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row xsmbt0">
                <div class="col-50 xscol-100 mbt15">
                    <div class="cst-input-field">
                        <label translate>lblColor  <strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong></label>
                        <input type="text" [readonly]="!isDFVehicleFound" formControlName="color" 
                        [ngClass]="(CustomerVehicleFormControls.color.touched || CustomerVehicleFormControls.color.dirty) && CustomerVehicleFormControls.color.errors?.required && isDFVehicleFound ? 'isinvalid' : ''"    
                        class="form-control" />
                        <div *ngIf="CustomerVehicleFormControls.color.touched || CustomerVehicleFormControls.color.dirty">
                            <div translate *ngIf="CustomerVehicleFormControls.color.errors?.required && isDFVehicleFound" class="cst-validation-msg">
                                lblColorRequired
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-50 xscol-100 mbt15" *ngIf="isShowDate">
                    <div class="cst-input-field">
                        <label translate>lblRegistrationDate </label>
                        <div class="lbl-info cal-date">
                        <input class="form-control datePicker width100force"   appAfDatepicker [(ngModel)]="FirstRegDate"
                          autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtFirstRegDate"
                          [ngClass]="!isDFVehicleFound ? 'disableDate' : ''"  [readonly]="!isDFVehicleFound"
                          formControlName="FirstRegDate" name="FirstRegDate" type="text" value="">
                        <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                </div>

                <div class="col-50 xscol-100 mbt15" *ngIf="isShowDate">
                    <div class="cst-input-field">
                        <label translate>lblLastRegistrationDate  </label>
                        <div class="lbl-info cal-date">
                        <input class="form-control datePicker width100force"  appAfDatepicker [(ngModel)]="LastRegDate"
                          autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtLastRegDate"
                          formControlName="LastRegDate" name="LastRegDate" type="text" value=""
                          [ngClass]="!isDFVehicleFound ? 'disableDate' : ''" [readonly]="!isDFVehicleFound">
                        <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                </div>

                <div class="col-50 xscol-100 mbt15" *ngIf="isShowDate">
                    <div class="cst-input-field">
                        <label translate>lblInspectionPrevDate  </label>
                        <div class="lbl-info cal-date">
                        <input class="form-control datePicker width100force"  appAfDatepicker [(ngModel)]="InspectionPrevDate"
                          autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtInspectionPrevDate"
                          formControlName="InspectionPrevDate" name="InspectionPrevDate" type="text" value=""
                          [ngClass]="!isDFVehicleFound ? 'disableDate' : ''" [readonly]="!isDFVehicleFound">
                        <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                </div>

                <div class="col-50 xscol-100 mbt15" *ngIf="isShowDate">
                    <div class="cst-input-field ">
                        <label translate>lblInspectionNextDate </label>
                        <div class="lbl-info cal-date">
                            
                          <input class="form-control datePicker width100force"  appAfDatepicker  [(ngModel)]="InspectionNextDate"
                            autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtInspectionNextDate"
                            formControlName="InspectionNextDate" name="txtInspectionNextDate" type="text" value=""
                            [ngClass]="!isDFVehicleFound ? 'disableDate' : ''"    [readonly]="!isDFVehicleFound">
                          <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                    </div>
                    </div>
                </div>



                <div class="col-50 xscol-100 mbt15" [hidden]="true">
                    <div class="cst-input-field">
                        <label translate>lblOwnername  <strong class="mlt6 required" *ngIf="isDFVehicleFound"> * </strong></label>
                        <input type="text" [readonly]="!isDFVehicleFound" formControlName="OwnerName" 
                        [ngClass]="(CustomerVehicleFormControls.OwnerName.touched || CustomerVehicleFormControls.OwnerName.dirty) && CustomerVehicleFormControls.OwnerName.errors?.required && isDFVehicleFound ? 'isinvalid' : ''"    
                        class="form-control" />
                        <div *ngIf="CustomerVehicleFormControls.OwnerName.touched || CustomerVehicleFormControls.OwnerName.dirty">
                            <div translate *ngIf="CustomerVehicleFormControls.OwnerName.errors?.required && isDFVehicleFound" class="cst-validation-msg">
                                lblOwnerNameRequired
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

            <div *ngIf="customerFormValue">
                <div class="row xsmbt0">
                    <div class="col-6 col-md-3 mbt15">
                        <div class="cst-input-field">
                            <label translate> lblFirstName <strong class="mlt6 required"> * </strong> </label>
                            <input type="text" formControlName="FirstName" 
                            [ngClass]="(CustomerVehicleFormControls.FirstName.touched || CustomerVehicleFormControls.FirstName.dirty) && CustomerVehicleFormControls.FirstName.errors?.required ? 'isinvalid' : ''"
                            class="form-control" />
                            <div *ngIf="CustomerVehicleFormControls.FirstName.touched || CustomerVehicleFormControls.FirstName.dirty">
                                <div translate *ngIf="CustomerVehicleFormControls.FirstName.errors?.required" class="cst-validation-msg">
                                    lblRequiredFirstName
                                </div>
                                <div translate *ngIf="CustomerVehicleFormControls.FirstName.errors?.pattern" class="cst-validation-msg">
                                    lblDigitsAreNotAllowed</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 col-md-3 mbt15 pl-2">
                        <div class="cst-input-field">
                            <label translate> lblLastName <strong class="mlt6 required"> * </strong> </label>
                            <input type="text" formControlName="LastName"
                            [ngClass]="(CustomerVehicleFormControls.LastName.touched || CustomerVehicleFormControls.LastName.dirty) && CustomerVehicleFormControls.LastName.errors?.required ? 'isinvalid' : ''"
                            class="form-control" />
                            <div *ngIf="CustomerVehicleFormControls.LastName.touched || CustomerVehicleFormControls.LastName.dirty">
                                <div translate *ngIf="CustomerVehicleFormControls.LastName.errors?.required" class="cst-validation-msg">
                                    lbRequiredlLastName
                                </div>
                                <div translate *ngIf="CustomerVehicleFormControls.LastName.errors?.pattern" class="cst-validation-msg">
                                    lblDigitsAreNotAllowed</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6  mbt15">
                        <div class="cst-input-field">
                            <label translate> lblEmail <strong class="mlt6 required"> * </strong> </label>
                            <input type="email" formControlName="Email" maxlength="50" 
                            [ngClass]="(isEmailChange) && CustomerVehicleFormControls.Email.errors ? 'isinvalid' : ''"
                            class="form-control" (change)="ValidateEmail()"/>
                            <div *ngIf="isEmailChange">
                                <div translate *ngIf="CustomerVehicleFormControls.Email.errors?.required" class="cst-validation-msg">
                                    lblEmailisrequired</div>
                                <div translate *ngIf="CustomerVehicleFormControls.Email.errors?.pattern" class="cst-validation-msg">
                                    lblPleaseEnterValidValue</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row xsmbt0">
                    <div class="col-50 xscol-100 mbt15">
                        <div class="cst-input-field">
                            <label translate>lblAddressLine1 <strong class="mlt6 required"> * </strong> </label>
                            <input type="text" formControlName="Address1" 
                            [ngClass]="(CustomerVehicleFormControls.Address1.touched || CustomerVehicleFormControls.Address1.dirty) && CustomerVehicleFormControls.Address1.errors?.required ? 'isinvalid' : ''"
                            class="form-control" />
                            <div *ngIf="CustomerVehicleFormControls.Address1.touched || CustomerVehicleFormControls.Address1.dirty">
                                <div translate *ngIf="CustomerVehicleFormControls.Address1.errors?.required" class="cst-validation-msg">
                                    lblAddressLine1Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-50 xscol-100 mbt15">
                        <div class="cst-input-field">
                            <label translate>lblAddressLine2 </label>
                            <input type="text" formControlName="Address2" class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="row xsmbt0">
                    <div class="col-50 xscol-100 mbt15">
                        <div class="cst-input-field">
                            <label translate>lblZipCode<strong class="mlt6 required"> * </strong> </label>
                            <ng-select formControlName="Zipcode" (change)="onPostCodeSelected($event)"
                            [ngClass]="(CustomerVehicleFormControls.Zipcode.touched || CustomerVehicleFormControls.Zipcode.dirty) && CustomerVehicleFormControls.Zipcode.errors?.required ? 'isinvalid' : ''"
                            >
                                <ng-option *ngFor="let item of postCodeList" [value]="item.code">
                                    {{item.code}}
                                </ng-option>
                            </ng-select>
                            <div *ngIf="CustomerVehicleFormControls.Zipcode.touched || CustomerVehicleFormControls.Zipcode.dirty">
                                <div translate *ngIf="CustomerVehicleFormControls.Zipcode.errors?.required" class="cst-validation-msg">
                                    lblZipCodeIsRequired</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-50 xscol-100 mbt15">
                        <div class="cst-input-field">
                            <label translate>lblCity <strong class="mlt6 required"> * </strong> </label>
                            <ng-select formControlName="City" (change)="onCitySelected($event)"
                            [ngClass]="(CustomerVehicleFormControls.City.touched || CustomerVehicleFormControls.City.dirty) && CustomerVehicleFormControls.City.errors?.required ? 'isinvalid' : ''"
                            >
                                <ng-option *ngFor="let item of cityList" [value]="item">
                                    {{item}}
                                </ng-option>
                            </ng-select>
                            <div *ngIf="CustomerVehicleFormControls.City.touched || CustomerVehicleFormControls.City.dirty">
                                <div translate *ngIf="CustomerVehicleFormControls.City.errors?.required" class="cst-validation-msg">
                                    lblCityIsRequired</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row xsmbt0">
                    <div class="col-50 xscol-100 mbt15">
                        <div class="cst-input-field">
                            <label translate> lblCountry <strong class="mlt6 required"> * </strong> </label>
                            <ng-select formControlName="CountryId"
                            [ngClass]="(CustomerVehicleFormControls.CountryId.touched || CustomerVehicleFormControls.CountryId.dirty) && CustomerVehicleFormControls.CountryId.errors?.required ? 'isinvalid' : ''"
                            >
                                <ng-option *ngFor="let item of countryDropdown" [value]="item.id">
                                    {{item.countryName}}
                                </ng-option>
                            </ng-select>
                            <div translate *ngIf="CustomerVehicleFormControls.CountryId.touched || CustomerVehicleFormControls.CountryId.dirty">
                                <div *ngIf="CustomerVehicleFormControls.CountryId.errors?.required" class="cst-validation-msg" translate>
                                    lblCountryIsRequired</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-50 xscol-100 mbt15">
                        <div class="cst-input-field">
                            <label translate>lblMobileNo <strong class="mlt6 required"> * </strong> </label>
                            <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="MobileNo" [cssClass]="{'form-control': true}" [disabled]="isMobileReadOnly" (keypress)="isDigit($event)"
                            [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="true"
                            [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                            (countryChange)="onCountryChange($event)"
                            ></ngx-intl-tel-input>                    
                            <div *ngIf="CustomerVehicleFormControls.MobileNo.touched || CustomerVehicleFormControls.MobileNo.dirty">
                                <div translate *ngIf="CustomerVehicleFormControls.MobileNo.errors?.required" class="cst-validation-msg" translate>
                                    lblMobileNumberIsRequired</div>
                                <div translate *ngIf="CustomerVehicleFormControls.MobileNo.errors?.pattern" class="cst-validation-msg">
                                    lblPleaseEnterValidValue</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="clearfix">


                <div class="row xsmbt0 mb-2" *ngIf="!isWidgetVehicleDMSSearch">
                    <div class="col-100 mbt15">
                        <div class="cst-input-field mb-2">
                            <label translate>lblRelationType<strong class="mlt6 required"> * </strong></label>
                        </div>
                        
                        <ul class="role-listing-horizonatl d-flex text-center fs16px medium" [ngClass]="ownertypes.length <=0 && isCustomerVehicleFormSubmited ? 'Reqisinvalid' : ''">
                            <li class="mr-2"><input type="checkbox" name="role" [checked]="ownertype.Owner" (change)="onCheckOwnerChange($event)" /><label><em class="fa-regular fa-500 fa icncheckmark fa-circle-check"></em><em class="fa fs20px fa-500 fa-regular fa-user"></em><p>Owner</p></label></li>
                            <li class="mr-2"><input [checked]="ownertype.Payer" type="checkbox" name="role" (change)="onCheckPayerChange($event)" /><label><em class="fa-regular fa-500 fa icncheckmark fa-circle-check"></em><em class="fa fs20px fa-500 fa-regular fa-credit-card"></em><p>Payer</p></label></li>
                            <li class="mr-2"><input type="checkbox" name="role" [checked]="ownertype.User" (change)="onCheckUserChange($event)" /><label><em class="fa-regular fa-500 fa icncheckmark fa-circle-check"></em><em class="fa fs20px fa-500 fa-regular fa-user"></em><p>User</p></label></li>
                            <li class="mr-2"><input type="checkbox" name="role" [checked]="ownertype.Driver" (change)="onCheckDrvierChange($event)" /><label><em class="fa-regular fa-500 fa icncheckmark fa-circle-check"></em><em class="fa fs20px fa-500 fa-regular fa-address-card"></em><p>Driver</p></label></li>
                        </ul>
                    </div>
                </div>


            </div>
        </div>
        <div class="modal-footer">
            <button translate type="submit" aria-label="Center Align" class="btn btn-primary btn-lg"
            [disabled]="!CustomerVehicleForm.valid || (!isWidgetVehicleDMSSearch && ownertypes.length <=0)">
                lblAddDetails</button>
        </div>
    </form>

</div>